import { render, staticRenderFns } from "./S1TouchWidget.vue?vue&type=template&id=18c93c8c"
import script from "./S1TouchWidget.vue?vue&type=script&lang=js"
export * from "./S1TouchWidget.vue?vue&type=script&lang=js"
import style0 from "./S1TouchWidget.vue?vue&type=style&index=0&id=18c93c8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports